<template>
    <div class="animated fadeIn">
      <user-form v-if="showUserForm" v-bind:user="user" v-bind:mode="$data.userInputMode"></user-form>
      <div v-if="showSite">
      <b-row>
          <b-col cols="12">
              <b-button v-on:click="goBack" variant="secondary">
                  <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
              </b-button>
          </b-col>
      </b-row>

      <b-row>
            <b-col cols="12">
                <h1 v-if="siteInfoLoaded">{{groupTitle}} - {{areaTitle}} - {{siteTitle}} (Site ID: {{this.$data.site.id}})</h1>
                <h1 v-if="!siteInfoLoaded"></h1>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <b-btn class="header-collapse" block href="#" v-b-toggle.mainDetails @click="showSiteDetails = !showSiteDetails">
                            <strong>Site Details  - Desktop version: {{desktopVersion}} &nbsp;<i :class="showSiteDetails ? 'fa fa-compress font-lg' : 'fa fa-expand font-lg'"></i></strong>
                        </b-btn>
                    </div>
                    <div v-if="!siteInfoLoaded" class="form-container">
                        <LoadingSpinner />
                    </div>
                    <b-collapse id="mainDetails" accordion="details" role="tabpanel"  v-model="showSiteDetails">
                        <div v-if="siteInfoLoaded" class="form-container">
                            <b-row>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="siteName">Name</label>
                                        <b-form-input v-model="site.site_name" type="text" id="siteName"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="siteEmail">Contact Email</label>
                                        <b-form-input v-model="site.email" type="text" id="siteEmail"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="siteContactNo">Contact No</label>
                                        <b-form-input v-model="site.contact_no" type="text" id="siteContactNo"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="siteAccountCode">Account Code</label>
                                        <b-form-input v-model="site.account_code" type="text" id="siteAccountCode"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <!--
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="siteShowPlatesManufacturer">Show Plates Manufacturer</label>
                                        <b-form-select id="siteShowPlatesManufacturer" v-if="showPlatesManufacturersLoaded" v-model="site.show_plates_manufacturer_id"
                                            :plain="true"
                                            :options="showPlatesManufacturers">
                                        </b-form-select>
                                        <div v-if="!showPlatesManufacturersLoaded">
                                            <i class="fa fa-spin fa-spinner"></i> Loading...
                                        </div>
                                    </b-form-group>
                                </b-col>
                                -->
                            </b-row>
                            <b-row>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label for="areaLogo">Upload Logo</label><br />
                                        <input type="file"
                                            :name="site.logo"
                                            :disabled="!allowSave"
                                            @change="filesChange($event.target.name, $event.target.files)"
                                            @size-exceeded="onLogoSizeExceeded"
                                            fileCount ="$event.target.files.length"
                                            accept="image/*" class="input-file">
                                    </b-form-group>
                                </b-col>
                                <b-col offset-sm="7" sm="2">
                                    <b-button class="btn-block" variant="outline-primary" :pressed.sync="site.is_mup_customer">MUP {{site.is_mup_customer ? 'On ' : 'Off'}}</b-button>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col>
                                    <b-btn v-b-toggle.collapse1 variant="secondary">Show Plates Manufacturers &nbsp;&nbsp;<i class="fa fa-angle-down"></i></b-btn>
                                    <b-collapse id="collapse1" class="mt-2">
                                        <b-row>
                                            <b-col sm="12">
                                                <b-card>
                                                    <div slot="header">
                                                        <strong>Available Show Plates Manufacturers</strong>
                                                    </div>
                                                    <div class="form-container">
                                                        <b-row>
                                                            <b-col sm="2">
                                                                <div class="mb-3">
                                                                    <strong>Added?</strong>
                                                                </div>
                                                            </b-col>
                                                            <b-col sm="10">
                                                                <div class="mb-3">
                                                                    <strong>Manufacturer</strong>
                                                                </div>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row v-for="manufacturer in combinedManufacturers" v-bind:key="manufacturer.id" class="output-row">
                                                            <b-col sm="2">
                                                                <b-button 
                                                                    variant="outline-primary" 
                                                                    :pressed.sync="manufacturer.isIncluded"
                                                                    v-on:click="manufacturerSelected(manufacturer)"
                                                                    block>
                                                                    <span v-if="manufacturer.isIncluded">Yes</span><span v-else>No</span>
                                                                </b-button>
                                                            </b-col>
                                                            <b-col sm="10">
                                                                <b-input-group>
                                                                    <b-form-input
                                                                    v-model="manufacturer.manufacturerName"
                                                                    type="text"
                                                                    class="form-control"
                                                                    :id="'manufacturer-' + manufacturer.id + '-' + manufacturer.manufacturerName"
                                                                    readonly
                                                                    ></b-form-input>
                                                                </b-input-group>
                                                            </b-col>
                                                        </b-row>
                                                    </div>
                                                </b-card>
                                            </b-col>
                                        </b-row>
                                    </b-collapse>
                                </b-col>
                                <b-col sm="2">
                                    <b-button class="btn-block" variant="outline-primary" :pressed.sync="site.allow_eire_plates">Irish Plates {{site.allow_eire_plates ? 'On ' : 'Off'}}</b-button>
                                </b-col>
                                <b-col v-if="site.allow_eire_plates" sm="2">
                                    <b-button class="btn-block" variant="outline-primary" :pressed.sync="site.eire_plates_default">Irish Default {{site.eire_plates_default ? 'On ' : 'Off'}}</b-button>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row v-if="!isUserReadOnly">
                                <b-col cols="12" sm="12" md="12">
                                    <p class="action-button-toolbar">
                                        <b-button v-on:click="updateSite" variant="primary" :disabled="!allowSave">
                                            <i class="fa fa-check"></i>&nbsp;Update Site
                                        </b-button>
                                        <b-button v-if="isUserSuperAdmin" v-on:click="deleteSite" variant="danger" :disabled="!allowSave">
                                            <i class="fa fa-trash"></i>&nbsp;Delete Site
                                        </b-button>
                                    </p>
                                    <b-alert v-if="siteSaveSuccess" variant="success" show><strong>Data saved successfully.</strong></b-alert>
                                    <b-alert v-if="siteSaveError" variant="danger" show><strong>Error saving data. Please try again.</strong></b-alert>
                                    <b-alert v-if="siteSaveInProgress" variant="info" show><strong>Saving data. Please wait...</strong></b-alert>
                                </b-col>
                            </b-row>
                        </div>
                    </b-collapse>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Associated Users</strong>
                    </div>
                    <div v-if="!usersLoaded" class="form-container">
                        <LoadingSpinner />
                    </div>
                    <div v-if="usersLoaded" class="form-container">
                        <b-row v-if="!isUserReadOnly">
                            <b-col cols="12" sm="12" md="6">
                                <p>
                                    <b-button v-on:click="loadUserForm()" variant="primary">
                                        <i class="fa fa-plus"></i>&nbsp;Add User
                                    </b-button>
                                </p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col v-for="user in users" cols="12" sm="12" md="6" v-bind:key="user.id">
                                <b-card :no-body="true" footer-class="px-3 py-2" :class="getActiveCardStatusClass(user)">
                                    <b-card-body class="p-3 clearfix">
                                    <i :class="getActiveStatusClass(user)" class="fa fa-user p-3 font-2xl mr-3 float-left"></i>
                                    <div class="h5 text-warning mb-0 mt-2">{{user.first_name}} {{user.last_name}}</div>
                                    <div class="text-muted text-uppercase font-weight-bold font-xs">{{user.email}}</div>
                                    <div class="text-muted text-uppercase font-weight-bold font-xs">Status: <span :class="getActiveStatusForeColourClass(user)"> {{user.approved == "1" ? 'Active' : 'Inactive'}}</span></div>
                                    </b-card-body>
                                    <div slot="footer">
                                    <b-link class="font-weight-bold font-xs btn-block text-muted" v-on:click="loadUserForm(user)">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
    </div>
</template>

<script>

  import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner'
  import { Promise } from 'q'
  import VueBase64FileUpload from 'vue-base64-file-upload'
  import { loadFile } from '../../shared/utils'
  import UserForm from '../../components/forms/User'
  import { Switch as cSwitch } from '@coreui/vue';

  const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    return {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Bearer ' + userObj.token,
      }
    };
}

const getAreaInfo = (($http, companyId, pageSlug) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        let area = {};
         $http.get('area/company/'+ companyId +'/slug/' + pageSlug, headersObj)
            .then((response) => {
                resolve(response.data.area);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getCompanyInfo = (($http, slug) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get('company/slug/' + slug, headersObj)
            .then((response) => {
                resolve(response.data.company);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getSiteInfo = (($http, companyId, branchId, pageSlug) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        let site = {};
        $http.get('site?company_id=' + companyId + '&area_id=' + branchId, headersObj)
            .then((response) => {
                response.data.sites.forEach(element => {
                    if (element.page_slug == pageSlug) {
                        site = element;
                    }
                });
                resolve(site);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getShowPlatesManufacturer = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("showplates/manufacturers", headersObj)
            .then((response) => {
                resolve(response.data.manufacturers);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getShowPlatesManufacturerForSite = (($http, siteId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("showplates/manufacturerBySite/" + siteId, headersObj)
            .then((response) => {
                resolve(response.data.manufacturers);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getShowPlatesManufacturers = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("showplates/manufacturers", headersObj)
            .then((response) => {
                resolve(response.data.manufacturers);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getUsers = (($http, params) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        let url = 'users?company_id=' + params.company_id;
        if (parseInt(params.area_id) > 0) {
            url += '&area_id=' + params.area_id;
        }
        if (parseInt(params.site_id) > 0) {
            url += '&site_id=' + params.site_id;
        }
        $http.get(url, headersObj)
            .then((response) => {
                resolve(response.data.users);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getSiteDesktopAppVersion = (($http, siteId) => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
    $http.get('reports/stats/siteDesktopAppVersion?site_id=' + siteId, headersObj)
      .then((response) => {
          resolve(response.data.desktopAppVersion);
      })
      .catch ((err) => {
          console.error(err);
          reject(err);
      });
  });
});

export default {
  name: 'site',
  components: {
      UserForm,
      LoadingSpinner: LoadingSpinner,
      VueBase64FileUpload,
      cSwitch
  },
  data () {
    return {
        showSiteDetails: false,
        user: {},
        showUserForm: false,
        showSite: true,
        siteInfoLoaded: false,
        siteSaveSuccess: false,
        siteSaveError: false,
        siteSaveInProgress: false,
        allowSave: true,
        usersLoaded: false,
        showPlatesManufacturersLoaded: false,
        company: {},
        area: {},
        site: {},
        users: [],
        showPlatesManufacturers: [],
        combinedManufacturers: [],
        allShowplateManufacturers: [],
        groupTitle: "",
        siteTitle: "",
        areaTitle: "",
        groupParamName: "",
        siteParamName: "",
        userAuthLevel: '',
        filterParams: {
            company_id: -1,
            area_id: -1,
            site_id: -1,
        },
        desktopVersion: 'searching...'
    }
  },
  watch: {
      'site.branch_name': function(val, oldVal) {
        if (val.length < 1) {
            this.$data.allowSave = false;
        }
        else {
            this.$data.allowSave = true;
        }
      },
      'site.contact_no': function(val, oldVal) {
        if (val.length < 1) {
            this.$data.allowSave = false;
        }
        else {
            this.$data.allowSave = true;
        }
      },
      'site.email': function(val, oldVal) {
        console.log(val);
        if (val.length < 1) {
            this.$data.allowSave = false;
        }
        else {
            this.$data.allowSave = true;
        }
      },
  },
  created () {
    this.load()
  },
  computed: {
    isUserReadOnly() {
        if (this.$data.userAuthLevel == 'Read Only') {
            return true;
        }
        else {
            return false;
        }
    },
    isUserSuperAdmin() {
        if (this.$data.userAuthLevel == 'Super Admin') {
            return true;
        }
        else {
            return false;
        }
    },
  },
  methods : {
    load() {
      const groupParam = this.$route.params.groupshortname;
      const areaParam = this.$route.params.areaname;
      const siteParam = this.$route.params.sitename;
      this.$data.groupParamName = groupParam;
      this.$data.siteParamName = siteParam;
      this.$data.areaParam = areaParam;

      // get the show plates mnufacturers list first
      // then get the site and company data
      getShowPlatesManufacturer(this.$http)
        .then((manufacturers) => {
            this.$data.showPlatesManufacturers = manufacturers;
            this.$data.showPlatesManufacturers.unshift({'value': 0, 'text': 'None'});
            this.$data.showPlatesManufacturersLoaded = true;
            return getCompanyInfo(this.$http, groupParam);
        })
        .then((companyData) => {
            this.$data.company = companyData;
            this.$data.groupTitle = companyData.company_name;
            return getAreaInfo(this.$http, companyData.id, areaParam);
        })
        .then((areaObj) => {
            this.$data.area = areaObj;
            this.$data.areaInfoLoaded = true;
            this.$data.areaTitle = areaObj.branch_name;
            return getSiteInfo(this.$http, areaObj.company_id, areaObj.id, siteParam)
        })
        .then((siteData) => {
            console.log(siteData);
            this.$data.site = siteData;
            this.$data.site.allow_eire_plates = siteData.allow_eire_plates == 1 ? true : false;
            this.$data.site.eire_plates_default = siteData.eire_plates_default == 1 ? true : false;
            this.$data.site.is_mup_customer = siteData.is_mup_customer == 1 ? true : false;
            
            this.$data.site.is_deleted = 0;
            this.$data.siteTitle = siteData.site_name;
            this.$data.siteInfoLoaded = true;

            this.$data.filterParams.company_id = this.$data.company.id;
            this.$data.filterParams.area_id = this.$data.area.id;
            this.$data.filterParams.site_id = this.$data.site.id;
            return getUsers(
                this.$http, 
                this.$data.filterParams
            );
        })
        .then((usersData) => {
            this.$data.usersLoaded = true;
            this.$data.users = usersData;
            return getSiteDesktopAppVersion(this.$http, this.$data.site.id);
        })
        .then((version) => {
            this.$data.desktopVersion = version;
            return getShowPlatesManufacturers(this.$http);
        })
        .then((allShowplateManufacturers) => {
            this.$data.allShowplateManufacturers = allShowplateManufacturers;
            return getShowPlatesManufacturerForSite(this.$http, this.$data.site.id);
        })
        .then((selectedManufacturers) => {
            
            const showPlatesManufacturersIds = selectedManufacturers.map(item => {
                return item.id;
            });
            this.$data.combinedManufacturers = [];
            this.$data.combinedManufacturers = this.$data.allShowplateManufacturers.map((item) => {
                let manufacturerInternal = {
                    id: item.id,
                    manufacturerName: item.manufacturer_name,
                    isIncluded: false
                };

                if (showPlatesManufacturersIds.indexOf(item.id) >= 0) {
                    manufacturerInternal.isIncluded = true;
                }
                return manufacturerInternal;
            });
            
            return this.getCurrentUser();            
        })
        .then((userDetails) => {
            this.$data.userAuthLevel = userDetails.auth;
        })
        .catch ((err) => {
            console.error(err);
        });
    },
    loadUserForm(user) {
        if (user) {
            this.$data.user = user;
            this.$data.userInputMode = 'edit';
        }
        else {
            let setupUser = {
                company_id: this.$data.company.id,
                area_id: this.$data.area.id,
                site_id: this.$data.site.id,
                first_name: '',
                last_name: '',
                email: '',
            }
            this.$data.userInputMode = 'addFromSite';
            this.$data.user = setupUser;
        }
        this.$data.showUserForm = true;
        this.$data.showSite = false;
    },
    getLogo (fileName) {
          return loadFile(fileName)
    },
    getCurrentUser () {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {
                resolve(user);
            }
            else {
                reject();
            }
        });
    },
    onSiteLogoFile() {
        console.log('on logo file');
    },
    onSiteLogoLoad(dataUri) {
        console.log('on logo load');
        this.$data.site.logo = dataUri;
    },
    onSiteLogoSizeExceeded() {
        console.log('on logo exceed');
    },
    getActiveStatusClass(user) {
        return user.approved == "1" ? 'bg-success' : 'bg-danger';
    },
    getActiveCardStatusClass(user) {
        return user.approved != "1" ? 'inactive-card' : '';
    },
    getActiveStatusForeColourClass(user) {
        return user.approved == "1" ? 'element-active' : 'element-disabled';
    },
    filesChange(fieldName, fileList) {
      if (!fileList.length) return;
      this.site.logo = fileList[0]
    },
    onLogoSizeExceeded() {
        console.log('on logo exceed');
    },
    goBack() {
      this.$router.go(-1);
    },
    closeUserForm() {
      this.load()
      this.$data.showSite = true
      this.$data.showUserForm = false;
    },
    clearAlerts() {
        this.$data.siteSaveSuccess = false;
        this.$data.siteSaveError = false;
        this.$data.siteSaveInProgress = false;
    },
    deleteSite() {
        // set the delete flag then update the group
        this.clearAlerts();
        this.$data.siteSaveInProgress = true;
        let headersObj = getHTTPHeaders();
        this.$http.delete('site/'+this.$data.site.id, headersObj)
        .then((response) => {
            if (response.data.success == true) {
                this.$data.siteSaveInProgress = false;
                this.$data.siteSaveSuccess = true;
            }
        })
        .catch ((err) => {
            console.error(err);
            this.$data.siteSaveInProgress = false;
            this.$data.siteSaveError = false;
        });
    },
    updateSite() {
        this.clearAlerts();
        this.$data.siteSaveInProgress = true;
        let headersObj = getHTTPHeaders();

        const formData = new FormData();
        let payload = {
            id: this.$data.site.id,
            site_name: this.$data.site.site_name,
            contact_no: this.$data.site.contact_no,
            email: this.$data.site.email,
            show_plates_manufacturer_id: this.$data.site.show_plates_manufacturer_id,
            company_id: this.$data.company.id,
            area_id: this.$data.area.id,
            account_code: this.$data.site.account_code,
            logo: this.$data.site.logo,
            is_deleted: this.$data.site.is_deleted,
            allow_eire_plates: this.$data.site.allow_eire_plates == true ? 1 : 0,
            eire_plates_default: this.$data.site.eire_plates_default == true ? 1 : 0,
            is_mup_customer: this.$data.site.is_mup_customer == true ? 1 : 0 
        }
        for (let key in payload) {
          formData.append(key, payload[key])
        }

        formData.append('_method', 'PUT');

        this.$http.post('site/'+payload.id, formData, headersObj)
        .then((response) => {
            if (response.data.success == true) {
                this.$data.siteSaveInProgress = false;
                this.$data.siteSaveSuccess = true;
            }
        })
        .catch ((err) => {
            this.$data.siteSaveInProgress = false;
            this.$data.siteSaveError = false;
        });
    },
    manufacturerSelected(manufacturer) {

        let headersObj = getHTTPHeaders();
        let url = '';

        let dataPostObject = {
            site_id: this.$data.site.id,
            showplate_manufacturer_id: manufacturer.id
        };

        if (manufacturer.isIncluded == true) {
            url = 'showplates/sitemanufacturer/add';
        }
        else {
            url = 'showplates/sitemanufacturer/remove';
        }

        this.$http.post(url, dataPostObject, headersObj)
            .then((response) => {
                console.log(response.data);
            })
            .catch ((err) => {
                console.error(err);
            });
    }
  }
}
</script>

<style scoped>

    .toggle-group-button {
        position: absolute;
        right: 5%;
        top: 15%;
    }
    .group-active {
        color: #4dbd74!important;
    }
    .group-disabled {
        color: #f86c6b!important;
    }
    p.action-button-toolbar button {
        margin-right: 5px;
    }
    .row.output-row {
        padding-bottom: 8px;
    }
    .header-collapse {
        text-align: left;
        padding: 0;
        background-color: #f0f3f5;
        border: 0;
    }
    .header-collapse:focus, .header-collapse:active {
        box-shadow: none;
    }
</style>
